import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-muted"
}

import {
    OnlineChatUpdateDialogStatusActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import ActionBlockPreviewItem from "~/cabinet/vue/client/events/action/types/ActionBlockPreviewItem.vue";
import {useActionBlockPreviewProps} from "~/cabinet/vue/client/events/action/types/useActionBlockPreview";
import {computed} from "vue";


const __default__ = {
    name: "OnlineChatUpdateDialogStatusBlockPreview"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
        ...useActionBlockPreviewProps<OnlineChatUpdateDialogStatusActionDescription>()
    },
  setup(__props) {

let props = __props;

let status = computed(() => props.actionDescription.frontendParams.statusList.find(status => status.id == props.params.statusId));


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(status)?.isClosed)
      ? (_openBlock(), _createBlock(ActionBlockPreviewItem, {
          key: 0,
          label: "Ответственные"
        }, {
          default: _withCtx(() => [
            (_unref(props).params.isChangeAssigned)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  "model-value": [..._unref(props).params.newAssignedOperatorGroups, ..._unref(props).params.newAssignedOperatorLogins],
                  disabled: "",
                  multiple: "",
                  placeholder: "Убрать всех ответственных"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).actionDescription.frontendParams.groups, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: group.id,
                        label: group.descr
                      }, null, 8, ["value", "label"]))
                    }), 256)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).actionDescription.frontendParams.operators, (operator) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: operator.login,
                        label: operator.descr
                      }, null, 8, ["value", "label"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["model-value"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, "Без изменений"))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(props).params.markAsRead)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(ActionBlockPreviewItem, { label: "Помечать сообщения прочитанными" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                disabled: "",
                "model-value": _unref(props).params.markAsRead
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          (_unref(props).params.removeFromBuddyList && _unref(status)?.isClosed === true)
            ? (_openBlock(), _createBlock(ActionBlockPreviewItem, {
                key: 0,
                label: "Удалять из списка контактов"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    disabled: "",
                    "model-value": _unref(props).params.removeFromBuddyList
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})